export default ".tooltipListUser {\n  /*\twidth: 100%;\n  \tmax-height: 200px;\n  \toverflow-y: auto;\n  \toverflow-x: hidden;*/\n}"